import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

import type { BankAccount, ElectronicAccountType } from './types';

type Variables = {
  accountNumber: string;
  routingNumber: string;
  accountType: ElectronicAccountType;
  address1: string;
  address2?: string;
  city: string;
  region: string;
  postalCode: string;
  country: string;
};

type Response = BankAccount;

// Used for both connecting a new account and editing (which replaces the
// existing recipient). Maps to Mercury's createRecipient electronicRoutingInfo.
export const useCreateBankAccount = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/internal/partners/bank_accounts',
      method: 'POST',
      data: {
        account_number: variables.accountNumber,
        routing_number: variables.routingNumber,
        electronic_account_type: variables.accountType,
        address: {
          address1: variables.address1,
          address2: variables.address2,
          city: variables.city,
          region: variables.region,
          postal_code: variables.postalCode,
          country: variables.country,
        },
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        const errors = err.response?.data?.errors;
        throw new Error(
          Array.isArray(errors)
            ? errors.join(', ')
            : 'There was an issue with your bank account. Please contact support at support@eonrides.com.'
        );
      }),
});
